import React from 'react'
import Game from './Game'
import { render, getConfig, CONTENT_TYPE } from '@educaplay/core'
import { assetsUrl, GameProvider } from '@educaplay/core'
import { initialize } from '@educaplay/store'
import { getLetterPositions } from '../utils/table'
import { normaliceWord } from '../utils/correction'
import {  initErrorMonitoring } from '@educaplay/core/utils'

initErrorMonitoring("https://d1234f40a469b4f370656b10301456d6@o4509038211104768.ingest.de.sentry.io/4509067520311376", {
  tracesSampleRate: 0.05
});

const gameImage = assetsUrl("CRUCIGRAMA/logoActivity.png");
const container = document.getElementById('root');
const MAX_POINTS = 100;

async function init() {
  const { data, texts, settings, user, title, description, author, id, url } = await getConfig().catch((err) =>
    console.error('Error al obtener la configuración: ', err)
  )

  const CRUCIGRAMA_SOUNDS = {
    "goodActive": assetsUrl('CRUCIGRAMA/bienactivo.mp3'),
    "move": assetsUrl('CRUCIGRAMA/mover.mp3'),
    "write": assetsUrl('CRUCIGRAMA/escribir_low.mp3'),
    "correct": assetsUrl('CRUCIGRAMA/correcto.mp3')
  }
  const { resources } = settings
  const screens = data.BLOQUES
    .filter(screen => screen.distribution !== false).map((question, index) => ({ ...question, screenID: index }));

  const questionTimeNumber = Number(data.TIEMPO)
  const questionTime = Number.isNaN(questionTimeNumber) ? 0 : questionTimeNumber
  const numQuestions = screens.reduce((acc, screen) => acc + screen.PREGUNTAS.length, 0);
  const questions = screens.flatMap(screen => {
    const screenQuestions = screen.PREGUNTAS;
    const distributions = screen.distribution;

    return distributions.words.map((distribution) => {
      const question = screenQuestions[distribution.id];
      if (!question.RESPUESTAS[0].RESPUESTA) return null;
      const correctAnswer = question.RESPUESTAS[0].RESPUESTA;
      const questionPoints = MAX_POINTS / numQuestions;

      const checkAnswer = (answer) => {
        return normaliceWord(answer) === normaliceWord(correctAnswer);
      }

      const calculatePoints = (_answer, { tries = [] }) => {
        if (data.NUMERO_INTENTOS_INFINITOS === "si") return questionPoints;
        if (tries.length === 0) return questionPoints;
        if (tries.length === 1) return questionPoints / 2;
        if (tries.length === 2) return questionPoints / 4;
        return 0;
      }

      return {
        id: distribution.id + screens.slice(0, screen.screenID).reduce((acc, screen) => acc + screen.PREGUNTAS.length, 0),
        screenID: screen.screenID,
        time: questionTime,
        bank: (question.ENUNCIADO || question.MULTIMEDIA) ? {
          text: question.ENUNCIADO,
          source: `${resources}${question.MULTIMEDIA}`,
          type: question.MULTIMEDIA_TIPO ?? CONTENT_TYPE.TEXT,
        } : null,
        checkAnswer,
        calculatePoints,
        correctAnswers: [correctAnswer],
        answer: null,
        points: questionPoints,
        lettersPositions: getLetterPositions(distribution, correctAnswer),
        direction: distribution.direction,
        media: question.MULTIMEDIA ? {
          type: question.MULTIMEDIA_TIPO,
          src: question.MULTIMEDIA_TIPO === CONTENT_TYPE.YOUTUBE ? question.MULTIMEDIA : `${resources}${question.MULTIMEDIA}`,
        } : null,
        text: question.ENUNCIADO,
        number: distribution.id + 1
      }
    })
  }).filter(question => question !== null).sort((a, b) => {
    if (a.screenID === b.screenID) return a.id - b.id;
    return a.screenID - b.screenID;
  });
  
  initialize({
    lives: data.NUMERO_INTENTOS,
    liveActived: data.NUMERO_INTENTOS_INFINITOS !== "si",
    hasCountDown: data.MAXIMO === "si",
    randomized: data.ALEATORIO === "si",
    showSolutions: data.OCULTAR_RESPUESTAS !== "1",
    showRestart: data.OCULTAR_REINICIAR !== "1",
    showSocialMedia: data.OCULTAR_REDES !== "1",
    finalText: data.TEXTO_FINAL,
    automaticallyFinishGame: false,
    hasProgressBar: { view: true, onlyCorrect: true },
    hasBank: false,
    hasInfinityTries: true,
    globalCountdown: data.TIEMPO,
    showUserTries: true,
    questions,
    countFooterSpace: true,
    settings,
    title,
    description,
    author,
    id,
    url,
    user,
    customizations: {
      customLogo: data.LOGO,
      customBarLogo: data.FRANJA,
      backgroundImage: { src: data.BACKGROUND, showGame: true },
      colors: {
        primary: data.COLOR_FONDO,
        text: data.COLOR_FUENTE,
        action: data.COLOR_BOTONES,
        textAction: data.COLOR_FUENTE_B,
      }
    }
  });

  render(container, (
    <React.StrictMode>
      <GameProvider
        gameImage={gameImage}
        texts={texts}
        Game={Game}
        sounds={CRUCIGRAMA_SOUNDS}
        mappers={{
          report: (question) => {
            const isCorrect = question.checkAnswer(question.answer);
            const questionIdCurrentScreen = question.id - screens.slice(0, question.screenID).reduce((acc, screen) => acc + screen.PREGUNTAS.length, 0);
            const triesArray = question.tries.map(entry => {

              return {
                s: false,
                i: `${question.screenID}:${questionIdCurrentScreen}`,
                a: entry
              }
            });

            if (!isCorrect) return [...triesArray]

            const answer = {
              s: isCorrect,
              i: `${question.screenID}:${questionIdCurrentScreen}`,
              a: question.answer
            }
            return [...triesArray, answer];
          }
        }}
      />
    </React.StrictMode>
  ))
}

init();